import Select from 'common/components/form/inputs/Select';

const IndexTypeSelector = ({ filter, value, onChange, isMulti, label, placeholder }) => {
  const options = [
    { id: 'V', name: 'Voyage' },
    { id: 'T', name: 'TC' }
  ];

  return (
    <Select
      label={label}
      placeholder={placeholder ? placeholder : 'Select value'}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      value={filter ? (filter.value && Array.isArray(filter.value) ? filter.value : []) : value}
      options={options}
      isMulti={isMulti}
      onChange={selected =>
        onChange({
          data: selected ? selected : [],
          value: selected ? (isMulti ? selected : selected) : ''
        })
      }
      isClearable
    />
  );
};

export default IndexTypeSelector;
